<template>
  <!-- 

  [ type a 보더 옵션 / default : 없음 ]
  .style--border

  [ 히든 옵션 / default : 없음 ]
  .hidden--search
  -->

  <header class="header-horizontal-type-e hidden--search">
    <div class="logo-container">
      <button
        class="btn--vetical-header-hidden"
        type="button"
        @click="$emit('clickVerticalHeaderBtn')"
      ><i class="material-icons">dehaze</i></button>
      <logo class=""></logo>
    </div>
    <div class="search-container">
      <form-search
        label="search"
        :error="error"
        v-model="row.search"
        name="searchText"
      ></form-search>
    </div>
    <div class="menu-user-container icon--hidden">
      <menu-user class="horizontal"></menu-user>
    </div>
  </header>

</template>

<script>
import menu from '../js/menu'

export default {
  mixins: [menu],
  data () {
    return {
      row: {
        search: ''
      },
      error: {}
    }
  },
  components: {
    Logo: () => import('@/component/common/Logo'),
    // MenuMain: () => import('@/component/layout/header/common/MenuMain'),
    MenuUser: () => import('@/component/layout/header/common/MenuUser'),
    FormSearch: () => import('@/component/ui2/form/FormSearch')
  }
}
</script>
